<template>
  <div class="row categoria-indicadores">
    <h3 class="titulo">{{ titulo }}</h3>
    <div class="col-md-3 col-sm-6 col-xs-12"
         v-for="registro in orderBy(listaFiltrada, 'label')"
         :key="registro.id">
      <div class="info-box bg-yellow">
        <span class="info-box-icon"><i :class="registro.icone"></i></span>
        <div class="info-box-content">
          <span class="info-box-text-legenda" v-if="idioma === 'DE'">{{registro.labelDe}}</span>
          <span class="info-box-text-legenda" v-else-if="idioma === 'EN'">{{registro.labelEn}}</span>
          <span class="info-box-text-legenda" v-else-if="idioma === 'ES'">{{registro.labelEs}}</span>
          <span class="info-box-text-legenda" v-else>{{registro.labelPtBr}}</span>

          <span class="info-box-number" v-if="!registro.is_bool">
            {{registro.valor | currency('', 2, { thousandsSeparator: '.', decimalSeparator: ',' })}}
            <small> {{registro.unidade_medida}}</small>
          </span>
          <span class="info-box-number" v-else-if="registro.valor">On</span>
          <span class="info-box-number" v-else>Off</span>

          <div class="progress">
            <div class="progress-bar" style="width: 100%"></div>
          </div>
          <span class="progress-description">
            {{registro.data_atualizacao}}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue2Filters from 'vue2-filters'

export default {
  name: 'CategoriaIndicadores',
  mixins: [Vue2Filters.mixin],
  props: {
    titulo: { type: String, required: true },
    ids: { type: Array, required: true },
    registros: { type: Array, required: true },
    idioma: { type: String, required: true }
  },
  computed: {
    listaFiltrada () {
      return this.registros.filter(r => this.ids.includes(r.campo) && r.exibir)
    }
  }
}
</script>
<style scoped>

/* Permite quebra de linha nos textos longos */
.titulo {
  padding: 0 0 0 10px;
}

.info-box-text-legenda {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  font-size: 1.3rem;
  line-height: 1.1em;
  white-space: normal;
  word-break: break-word;
}

.info-box-icon {
  display: flex;
  align-items: center;         /* centraliza o ícone verticalmente */
  justify-content: center;     /* centraliza horizontalmente */
  width: 80px;                 /* largura fixa padrão */
  background: rgba(0,0,0,0); /* mantém contraste */
  font-size: 50px;
  color: #fff;
  flex-shrink: 0;              /* evita que o ícone reduza demais */
}

/* Ajusta o conteúdo para ocupar o resto do espaço */
.info-box-content {
  flex: 1;
  padding: 5 30 0 0px;
  overflow: visible;
}
</style>



// WEBPACK FOOTER //
// CategoriaIndicadores.vue?2a806c26